@if (platformUser()) {
  <ng-container *transloco="let t; prefix: 'platformPortal.home'">
  <div class="launcher">
    <app-home-tabs
      [tabs]="homeTabs()"
      [activeId]="activeTab()"
      (tabSelected)="selectTab($event)"
    ></app-home-tabs>

    <div class="launcher-header">
      <div>
        @let title = activeContent().title;
        @let blurb = activeContent().blurb;
        <h1>{{ isKey(title) ? t(title.key, title.params) : title.text }}</h1>
        <p>{{ isKey(blurb) ? t(blurb.key, blurb.params) : blurb.text }}</p>
      </div>
      <span class="launcher-count">{{
        activeContent().tiles.length === 1
          ? t("moduleCount.one")
          : t("moduleCount.other", { count: activeContent().tiles.length })
      }}</span>
    </div>

    @if (activeContent().tiles.length > 0) {
      <div class="module-grid">
        @for (entry of activeContent().tiles; track entry.tile.enumeration) {
          <div
            class="tile"
            [routerLink]="
              entry.matchedContainedModule?.routes?.[0] ?? entry.tile.routes[0]
            "
          >
            <div class="tile-header">
              <div class="tile-name">{{ entry.tile.name }}</div>
              <button
                type="button"
                class="pin-button"
                [class.pinned]="isPinned(entry.tile.enumeration)"
                [attr.aria-label]="
                  isPinned(entry.tile.enumeration) ? t('unpin') : t('pin')
                "
                (click)="togglePin(entry.tile.enumeration, $event)"
              >
                <mat-icon>{{
                  isPinned(entry.tile.enumeration) ? 'star' : 'star_border'
                }}</mat-icon>
              </button>
            </div>
            <div class="tile-desc">{{ entry.tile.description }}</div>
            @if (newFeedbackCount() && isFeedbackTile(entry.tile)) {
              <div class="tile-badge" data-testid="feedback-badge">
                {{ t("newFeedback", { count: newFeedbackCount() }) }}
              </div>
            }
            @if (entry.matchedContainedModule) {
              <div class="tile-submodule-note">
                <strong>{{
                  t("contains", { name: entry.matchedContainedModule.name })
                }}</strong>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      @let empty = emptyText();
      <div class="no-results">
        {{ isKey(empty) ? t(empty.key, empty.params) : empty.text }}
      </div>
    }
  </div>
  </ng-container>
}
